<div class="flyout-container">
  <div class="header-accordion">
    <ion-header class="ion-no-border ion-header-menu">
      <ion-toolbar class="toolbar-background">
        <ion-buttons slot="end">
          <ion-button
            (click)="closeSortFilterMenu()"
            class="close-button"
            data-cy="close-sidebar-button"
          >
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-accordion-group [value]="'first'" #accordionGroup>
      <ion-accordion value="first">
        <ion-item class="title" slot="header" color="white">
          <ion-label>{{ 'i18n.common.sortBy' | translate }}</ion-label>
        </ion-item>
        <div
          *ngIf="platformType === platformRef.mobile"
          class="chip-container"
          slot="content"
        >
          <app-usf-chip
            *ngIf="
              (!isRecentlyPurchased &&
                sortFilterOptions?.sortType !== listConstants.groupLine) ||
              (isRecentlyPurchased &&
                sortFilterOptions?.sortType !== listConstants.date)
            "
            [type]="chipTypeEnum.selectedFilter"
            [iconConfig]="{
              rightIcon: true,
              color: '#56821f',
              iconUrl: 'assets/icon/close.svg',
            }"
            [clickable]="true"
            (clickEmitter)="clearSort()"
          >
            {{ getSortText(sortFilterOptions?.sortType) | translate }}:
            {{ getSortDirection(sortFilterOptions?.sortDirection) | translate }}
          </app-usf-chip>
        </div>
        <ion-item
          *ngFor="let sortButton of sortButtons"
          class="sort-filter-row sort"
          slot="content"
          (click)="selectSort(sortButton.sortValue)"
        >
          <div class="labels">
            <ion-label
              [class.selected]="
                sortFilterOptions?.sortType === sortButton.sortValue
              "
              >{{ sortButton.fieldName | translate }}</ion-label
            >
            <ion-label
              *ngIf="sortFilterOptions?.sortType === sortButton.sortValue"
              class="sort-direction"
            >
              {{
                (sortFilterOptions?.sortDirection === listConstants.asc
                  ? 'i18n.common.sortAscending'
                  : 'i18n.common.sortDescending'
                ) | translate
              }}
            </ion-label>
          </div>
          <ion-icon
            *ngIf="sortFilterOptions?.sortType !== sortButton.sortValue"
            src="assets/icon/sort-by.svg"
          ></ion-icon>
          <ion-icon
            *ngIf="
              sortFilterOptions?.sortType === sortButton.sortValue &&
              sortFilterOptions?.sortDirection === listConstants.asc
            "
            src="assets/icon/sort-asc.svg"
          ></ion-icon>
          <ion-icon
            *ngIf="
              sortFilterOptions?.sortType === sortButton.sortValue &&
              sortFilterOptions?.sortDirection === listConstants.desc
            "
            src="assets/icon/sort-desc.svg"
          ></ion-icon>
        </ion-item>
      </ion-accordion>
      <ion-accordion value="second">
        <ion-item class="title" slot="header" color="white">
          <ion-label>{{ 'i18n.common.filterBy' | translate }}</ion-label>
        </ion-item>
        <div class="chip-container" slot="header">
          <app-usf-chip
            *ngFor="let filter of sortFilterOptions?.filters"
            [type]="chipTypeEnum.selectedFilter"
            [iconConfig]="{
              rightIcon: true,
              color: '#56821f',
              iconUrl: 'assets/icon/close.svg',
            }"
            [clickable]="true"
            (clickEmitter)="selectFilter(filter, $event)"
          >
            {{ getFilterText(filter) | translate }}
          </app-usf-chip>
        </div>
        <ion-item
          *ngFor="let filterButton of filterButtons"
          class="sort-filter-row filter"
          slot="content"
          lines="full"
        >
          <ion-checkbox
            mode="ios"
            [checked]="sortFilterOptions?.filters?.includes(filterButton.id)"
            (ionChange)="selectFilter(filterButton.id)"
          >
            {{ filterButton.label | translate }}
          </ion-checkbox>
        </ion-item>
      </ion-accordion>
    </ion-accordion-group>
  </div>

  <!-- Footer -->
  <div class="footer">
    <ion-buttons>
      <ion-button
        expand="block"
        [ngClass]="
          platformType !== platformRef.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="clearAll()"
      >
        {{ 'i18n.common.clearAll' | translate }}
      </ion-button>
      <ion-button
        expand="block"
        [ngClass]="
          platformType !== platformRef.mobile
            ? sortFilterOptions
              ? 'usf-fill-green-dsktp-tblt-modal-button'
              : 'usf-fill-disabled-dsktp-tblt-modal-button'
            : sortFilterOptions
              ? 'usf-fill-green-mobile-modal-button'
              : 'usf-fill-disabled-mobile-modal-button'
        "
        (click)="closeSortFilterMenu()"
      >
        {{ 'i18n.requestCredit.close' | translate }}
      </ion-button>
    </ion-buttons>
  </div>
</div>
